export const isAndroid = (): boolean => {
  const u = navigator.userAgent;
  const isAndroid = u.indexOf('Android') > -1 || u.indexOf('Linux') > -1; // g
  return isAndroid;
};

export const isIOS = (): boolean => {
  const u = navigator.userAgent;
  const isIOS = !!u.match(/\(i[^;]+;( U;)? CPU.+Mac OS X/); // ios终端
  return isIOS;
};

export function isApp(): boolean {
  return /Contigo/i.test(window.navigator.userAgent);
}
